import { Star } from 'lucide-react';
import type { ScanCandidateDto } from 'shared';
import { toast } from 'sonner';

import { useToggleWatch } from '../../features/marketConsole/mutations';
import { cn } from '../../lib/utils';

export function WatchStarButton({ candidate }: { candidate: ScanCandidateDto }) {
  const toggle = useToggleWatch();
  const label = candidate.watched
    ? `Remove ${candidate.symbol} from watchlist`
    : `Add ${candidate.symbol} to watchlist`;
  return (
    <button
      type="button"
      aria-label={label}
      aria-pressed={candidate.watched}
      title={label}
      disabled={toggle.isPending}
      onClick={() =>
        toggle.mutate(
          { symbol: candidate.symbol, watched: candidate.watched },
          {
            onError: (error) =>
              toast.error(
                error instanceof Error ? error.message : `Could not update ${candidate.symbol}.`,
              ),
          },
        )
      }
      className="inline-flex h-9 w-9 items-center justify-center rounded text-text-muted transition hover:bg-surface-raised hover:text-text disabled:opacity-50"
    >
      <Star
        className={cn('h-4 w-4', candidate.watched && 'fill-warn text-warn')}
        aria-hidden="true"
      />
    </button>
  );
}
